import __request__ from "routing/request";
export function parse(JSONbody, requestOptions) {
  return __request__("POST", "/messages/parse", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function analyze(index, string, analyzer, requestOptions) {
  return __request__("GET", `/messages/${index}/analyze`, null, { "analyzer": analyzer, "string": string }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function search(index, messageId, requestOptions) {
  return __request__("GET", `/messages/${index}/${messageId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
